import { create } from 'zustand';
import { ApiUtils, ApplicationApi, ManualApplicationDownloadParams, RequestStrategyEnum } from '@shared/api';

interface IApproveManualApplicationStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  approveManualApplication: (searchParams: ManualApplicationDownloadParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApproveManualApplicationStore = create<IApproveManualApplicationStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  approveManualApplication: ApiUtils.wrapperApi(async (searchParams: ManualApplicationDownloadParams, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await ApplicationApi.approveManualApplication(searchParams, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
